import React from 'react';
import { RaosWrapper } from 'raos';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import usage from '../imnages/usage.png';

const StartCont = styled.div`
  height: 100%;
  margin-top: 1rem;
  padding: 1rem;
  box-shadow: ${boxShadow.outset};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: .5rem;
`
const Title = styled.h2`
  text-transform: uppercase;
  border-bottom: 5px solid ${color.prim};
  //box-shadow: ${boxShadow.inset};
  padding: .5rem 0;
`
const Info = styled.p`
  text-align: justify;
`
const MyName = styled(Info)`
  font-style: italic;
  text-transform: capitalize;
  align-self: flex-end;
`
const InstallCont = styled.div`
  margin-top: 1rem;
  border-radius: .5rem;
  padding: 1rem;
  box-shadow: ${boxShadow.inset};
  width: 100%;
  font-family: "Roboto";
`
const CodeImg = styled.img`
  width: 100%;
  object-fit: cover;
  object-position: center;
`
const Link = styled.a`
  color: ${color.prim};
  font-weight: bold;
  &:visited{
    color: ${color.tri};
  }
`
export default ()=> {

  return(
    <Container>
      <Row>
        <Col xs={12} sm={12}>
          <RaosWrapper style={{ opacity: 0 }} className="animated fadeInUp" percent={10}>
            <StartCont id="start" style={{ height: "auto" }}>
              <Title>installation</Title>
              <InstallCont>
                <Info style={{ textAlign: "center", margin: 0 }}>
                  npm install --save raos or yarn add raos
                  <br />
                <span style={{ color: "#aaa" }}>//Optional: you can install animate.css to animate</span><br/>
                  npm install --save anime.css or yarn add animate.css
                </Info>
              </InstallCont>
            </StartCont>
          </RaosWrapper>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6}>
          <RaosWrapper style={{ height: '100%', opacity: 0 }} className="animated fadeInLeft" percent={10}>
            <StartCont>
              <Title>description</Title>
              <Info>
                RAOS is a small library that helps animate components when intercepted on screen. Once the user scrolls to the position of their component, their own classes or third-party libraries will be added, which contain the animation.
              </Info>
              <Info>
                The examples used below are based on <Link target="_blank" href="https://daneden.github.io/animate.css/">animate.css</Link>, however you can use the css library of your choice, as well as your own classes. RAOS at its core, only intercepts components on screen and adds the classes that are provided by the user, this means that you could not only add animation classes, you could add classes for different purposes.
              </Info>
              <MyName>-felix tineo, creator.</MyName>
            </StartCont>
          </RaosWrapper>
        </Col>
        <Col xs={12} sm={6}>
          <RaosWrapper style={{ height: '100%', opacity: 0 }} className="animated fadeInRight" percent={10}>
            <StartCont>
              <Title>usage</Title>
              <InstallCont>
                <CodeImg src={usage} alt="raos usage" />
              </InstallCont>
            </StartCont>
          </RaosWrapper>
        </Col>
      </Row>
    </Container>
  )
}
